export default "__VITE_ASSET__B2g_pT6z__"